import { render } from "./App.vue?vue&type=template&id=9d5c5340"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9d5c5340&lang=css"

import exportComponent from "/home/mahdi/tmp/management/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__